/* eslint-disable camelcase */
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import { IconButton, TextField, TextFieldProps } from "@mui/material";
import React, { useState } from "react";

interface InputWithSearchProps {
  defaultValueSearch: string;
  handleChangeSearchText: (value: string) => void;
  textFieldProps?: TextFieldProps;
}

interface SearchAdornmentProps {
  existText: boolean;
  handleChangeSearchText: (value: string) => void;
  textValue: string;
}

function SearchAdornment(props: SearchAdornmentProps) {
  const { existText, handleChangeSearchText, textValue } = props;
  return (
    <>
      {existText && (
        <IconButton onClick={() => handleChangeSearchText("")}>
          <CloseIcon sx={{ opacity: "50%" }} />
        </IconButton>
      )}
      <IconButton onClick={() => handleChangeSearchText(textValue)}>
        <SearchIcon sx={{ transform: "rotate(90deg)", opacity: "50%" }} />
      </IconButton>
    </>
  );
}

export function InputWithSearch(props: InputWithSearchProps) {
  const { defaultValueSearch, handleChangeSearchText, textFieldProps } = props;

  const [textValue, setTextValue] = useState<string>(defaultValueSearch);

  const existText = textValue.trim().length > 0;

  function executeSearch(event: any) {
    if (event.key === "Enter") {
      handleChangeSearchText(textValue);
    }
  }

  return (
    <TextField
      fullWidth
      variant="outlined"
      defaultValue={defaultValueSearch}
      placeholder="Search"
      aria-label="search-input"
      value={textValue}
      onChange={(e) => setTextValue(e.target.value)}
      onKeyUp={(event: any) => {
        if (event.key === "Enter") executeSearch(event);
      }}
      InputProps={{
        endAdornment: (
          <SearchAdornment
            existText={existText}
            handleChangeSearchText={(value) => {
              handleChangeSearchText(value);
              setTextValue(value);
            }}
            textValue={textValue}
          />
        ),
        sx: {
          ".MuiInputBase-input": { padding: 0 },
          paddingLeft: 1,
          paddingRight: 0.5,
        },
      }}
      {...textFieldProps}
    />
  );
}
